<template>

<v-content class="mt-12">
    <v-card
        width=600
        flat
        dark
        class="mx-auto blueMain">
        <div class="text-center my-2 blueGrey--text">
            <v-icon class=" blueGrey--text">radio_button_checked</v-icon>
            Товар
        </div>

<!-- Shops card -->
        <v-card
            dark
            class="blueDark">
            <v-expansion-panels
                accordion
                dark
                flat
                focusable>
                <v-expansion-panel
                    v-for="shopid in totalInfo.shoplist"
                    :key="shopid"
                    class="blueDark">
                    <v-expansion-panel-header>
                        <div class="">
                            {{shopinfo[shopid].shopname.split(' ')[0]}}
                        </div>
                        <div class="orangeMain--text">
                            {{shopinfo[shopid].shopname.split(' ').slice(1,).join(' ')}}
                        </div>
                    </v-expansion-panel-header>

                    <v-lazy
                        :options="{ threshold: .5 }"
                        transition="fade-transition">

                        <ShopGoods :goods="data[shopid]"
                        :shopid="shopid"/>

                    </v-lazy>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
    </v-card>
</v-content>

</template>

<script>

import ShopGoods from './shop-goods'
import {mapState} from 'vuex'
import axios from 'axios'

export default {
name: 'ShopGoodsList',
components: {
    ShopGoods
},

data: () => ({
  data: {}
}),

computed: {

    ...mapState(['shopinfo', 'totalInfo', 'domen', 'date']),
    
},

methods: {
    async getdata() {
      return axios.post(this.domen + '/service/statproduct', {
        'year': new Date(this.date).getFullYear(),
        'month': new Date(this.date).getMonth() + 1,
        'shopID': 'all'
      }).then(res => res.data)
        .then(json => {
          this.data = json['response']
          .reduce((acc, n) => (acc[n.shopID] = n.data
            .sort((a,b) => b.money - a.money), acc), {});
      });
    },
},

watch:{

  date (){
    this.getdata();
  },

},

created: function() {
  this.getdata();
}
}
</script>
<style scoped>
</style>
